import React, { useContext } from 'react';
import { TimePicker as AntTimePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/ru';
import locale from 'antd/es/date-picker/locale/ru_RU';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { ValidationContext } from './Validation';

const TIME_FORMAT = 'HH:mm';

type TimePickerSizeType = 'large' | 'middle' | 'small';

interface TimePickerProps {
  value?: Date | null;
  placeholder?: string;
  disabled?: boolean;
  size?: TimePickerSizeType;
  allowClear?: boolean;
  onChange?: (time: Date | null) => void;
  className?: string;
  testId?: string;
}

function TimePicker({
  value,
  placeholder,
  disabled,
  size,
  allowClear,
  onChange,
  className,
  testId,
}: TimePickerProps): JSX.Element {
  const { validateStatus } = useContext(ValidationContext);

  const handleChange = (time: unknown) => {
    const value = time as Dayjs | null;
    onChange && onChange(value ? value.toDate() : null);
  };

  return (
    <Styled
      value={value ? dayjs(value) : null}
      size={size ? size : 'large'}
      format={TIME_FORMAT}
      placeholder={placeholder}
      disabled={disabled}
      allowClear={Boolean(allowClear)}
      onChange={handleChange}
      locale={locale}
      status={validateStatus}
      className={className}
      data-testid={testId}
    />
  );
}

const Styled = styled(AntTimePicker)`
  width: 100%;

  &.ant-picker {
    border-color: ${colorsPalette.lightGray300};
  }
`;

export default TimePicker;
export type { TimePickerProps };
